// List of allowed classes that should be visible to users
// All other classes will be blocked/hidden from the UI
export const ALLOWED_CLASSES = [
  "Accordion",
  "Audio Engineering",
  "Ballet",
  "Bass",
  "Cello",
  "Clarinet",
  "Dancing",
  "DJing",
  "Drums",
  "Flute",
  "Guitar",
  "Harp",
  "Music",
  "Music Production",
  "Oboe",
  "Piano",
  "Saxophone",
  "Singing",
  "Sound Mix",
  "Sound Therapy",
  "Trumpet",
  "Ukelele",
  "Violin",
];

/**
 * Filters subjects to only include allowed classes
 * @param {Array} subjects - Array of subject objects with 'title' property
 * @returns {Array} Filtered subjects array
 */
export const filterAllowedClasses = (subjects) => {
  if (!subjects || !Array.isArray(subjects)) {
    return [];
  }
  
  return subjects.filter((subject) =>
    ALLOWED_CLASSES.some(
      (allowedClass) =>
        allowedClass.toLowerCase() === subject.title?.toLowerCase()
    )
  );
};
